import React, { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../redux/store'

import {
  changeSimulationType,
  selectSelectedCareId,
  selectType,
  setSimulationCare,
} from '../../redux/reducers/simulation.reducer'
import { SimulationTypeChoice } from './SimulationTypeChoice'
import styled from '@emotion/styled'
import { CcamCodeForm } from './CcamCodeForm'
import { CommonCareForm } from './CommonCareForm'
import { getCares } from '../../redux/selectors'
import { CareSelection } from './CareSelection'
import { createSelector } from '@reduxjs/toolkit'
import { selectCommonCares } from '../../redux/reducers/commonCares.reducer'
import { mq } from '../breakpoints'
import { resetCcamCodes } from '../../redux/reducers/ccamCodes.reducer'

const selectCommonCaresByCategoryAndLabel = (
  categoryLabel: string,
  label: string
) =>
  createSelector(selectCommonCares, state =>
    state.value.filter(
      care => care.categoryLabel === categoryLabel && care.label === label
    )
  )

export const CareSelectionSection = () => {
  const dispatch = useAppDispatch()
  const simulationType = useAppSelector(selectType)
  const [selectedCcamCode, setSelectedCcamCode] = useState('')
  const [selectedCcamCategoryLabel, setSelectedCcamCategoryLabel] = useState('')
  const [selectedCategoryLabel, setSelectedCategoryLabel] = useState('')
  const [selectedLabel, setSelectedLabel] = useState('')

  let availableCares = []

  if (simulationType === 'ccam_code') {
    availableCares = useAppSelector(
      getCares(selectedCcamCode, selectedCcamCategoryLabel)
    )
  } else {
    availableCares = useAppSelector(
      selectCommonCaresByCategoryAndLabel(selectedCategoryLabel, selectedLabel)
    )
  }

  const selectedCareId =
    useAppSelector(selectSelectedCareId) ?? availableCares[0]?.id

  useEffect(() => {
    if (!availableCares.length) {
      return
    }

    dispatch(setSimulationCare(availableCares[0].id))
  }, [
    selectedCcamCode,
    selectedCcamCategoryLabel,
    selectedCategoryLabel,
    selectedLabel,
  ])

  useEffect(() => {
    setSelectedCcamCode('')
    setSelectedCcamCategoryLabel('')
    setSelectedLabel('')
    setSelectedLabel('')
    dispatch(resetCcamCodes())
  }, [simulationType])

  return (
    <div>
      <div style={{ maxWidth: '950px', margin: '0 auto' }}>
        <SimulationTypeChoice
          selectedType={simulationType}
          onChange={type => dispatch(changeSimulationType(type))}
        />
      </div>
      <div
        style={{
          width: '100%',
          maxWidth: '950px',
          margin: '0 auto',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <CcamCodeForm
          disabled={simulationType !== 'ccam_code'}
          onSelectionChange={(code, label) => {
            setSelectedCcamCode(code)
            setSelectedCcamCategoryLabel(label)
          }}
        />
        <CommonCareForm
          disabled={simulationType !== 'common_care'}
          onSelectionChange={(categoryLabel, label) => {
            setSelectedCategoryLabel(categoryLabel)
            setSelectedLabel(label)
          }}
        />
      </div>
      <CareSelection
        options={availableCares.map(care => {
          if (simulationType === 'ccam_code') {
            return {
              label: `${care.code}${
                care.categoryLabel ? ` - ${care.categoryLabel}` : ''
              }`,
              hint: `Base de remboursement ${care.referenceAmount ?? 0}€`,
              value: care.id,
            }
          } else {
            return {
              label: `${care.label}${
                care.additionalLabel ? ` - ${care.additionalLabel}` : ''
              }`,
              hint: `Base de remboursement ${care.referenceAmount ?? 0}€`,
              value: care.id,
            }
          }
        })}
        value={selectedCareId}
        onChange={(id: string) => {
          dispatch(setSimulationCare(id))
        }}
      />
    </div>
  )
}
